module.exports = __webpack_public_path__ + "static/media/30-5.ff830d37.mp3";